import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const WALLET_KEY = "mj_wallet";

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const wallet = localStorage.getItem(WALLET_KEY);
  if (wallet) config.headers["X-Wallet-Address"] = wallet;
  const previewToken = localStorage.getItem("mj_preview_token");
  if (previewToken) config.headers["X-Preview-Token"] = previewToken;
  return config;
});

export default api;
